<template>
    <div id="result" v-show="this.$store.state.showResult">
        <div class="banner">
            <img src="http://shared.youdao.com/dict/market/recite-vocabulary/imgs/mianbao.png" alt="">
            <div class="desc">
                <h6>单词量</h6>
                <p>{{this.$store.state.lastVocabulary}}</p>
                <span>{{this.desc}}</span>
            </div>
        </div>
        <div class="books">
            <p>推荐词书</p>
            <span>
                词汇量为&nbsp;<em>{{num}}</em>&nbsp;的词书最适合你学习噢！
            </span>
            <ul>
                <li v-for="(item, index) in booksList" :key="index">
                    <a @click="skipout(item)" data-rlog="recommend">
                        <img :src="item.cover" alt="">
                        <p>{{item.title}}</p>
                        <span>{{item.reciteUserNum}}人在背</span>
                    </a>
                </li>
            </ul>
        </div>
        <div class="rank">
            <p>当日排行</p>
            <ul>
                <li v-for="(item, index) in rankList" :key="index">
                    <div class="medal" v-html="index > 2 ? (index + 1) : ''"></div>
                    <img class="avatar" :src="item.avatar" >
                    <span class="name">{{item.nickName}}</span>
                    <span class="vocabulary">{{item.wordNumber}}</span>
                </li>
            </ul>
        </div>
        <div class="checkButton" v-if="showButten">
            <div class="share" @click="share" data-rlog="share-result"></div>
            <div class="certificate" @click="creatCard" data-rlog="generate-certificate"></div>
        </div>
        <div class="button" v-if="!showButten">
            <div class="share" @click="share" data-rlog="share-result"></div>
            <div class="certificate" @click="creatCard" data-rlog="generate-certificate"></div>
        </div>
        <creat-img :vocabulary="vocabulary" :showCreatedImg="showCreatedImg" @hiddenDialog="hiddenDialog"/>
        <input-name :showInput="showInput" @closedInput="closedInput" @getName="getName"/>
        <share-induce :toBrowser="toBrowser"/>
    </div>
</template>

<script>
    import { setShare, isYouDao, choiceDesc, getQueryString } from './../libs/libs.js'
    import { recommendBook, getWordFrequencyRank } from './../libs/sever.js'
    import InputName from './InputName'
    import CreatImg from './CreatImg'
    import ShareInduce from './ShareInduce'
    import { mapGetters } from 'vuex'
    export default {
        name: 'Result',
        data () {
            return {
                booksList: '',
                num: '',
                rankList: '',
                vocabulary: '',
                showButten: true,
                showCreatedImg: false,
                showInput: false,
                toBrowser: false,
                desc: ''
            }
        },
        mounted () {
            this.init()
        },
        computed:{
            ...mapGetters([
                'lastVocabulary',
                'bookList',
                'showResult'
            ])
        },
        watch: {
            showResult: function(val) {
                this.desc = choiceDesc(this.$store.state.lastVocabulary)
                if (this.$store.state.userName != '') {
                    this.vocabulary = this.$store.state.lastVocabulary
                }
            },
            bookList: function (val) {
                let that = this
                this.booksList = val
                console.log(val)
                this.booksList.forEach((item, index) => {
                    that.booksList[index].reciteUserNum = that.changeNum(item.reciteUserNum)
                });
                if (this.$store.state.lastVocabulary < 500) {
                    this.num = '0-500'
                } else if (this.$store.state.lastVocabulary < 2000){
                    this.num = '1000-2000'
                } else if (this.$store.state.lastVocabulary < 3000){
                    this.num = '2000-3000'
                } else if (this.$store.state.lastVocabulary < 4000){
                    this.num = '3000-4000'
                } else if (this.$store.state.lastVocabulary < 5500){
                    this.num = '4000-5000'
                } else if (this.$store.state.lastVocabulary < 6500){
                    this.num = '5500-6500'
                } else if (this.$store.state.lastVocabulary < 8500){
                    this.num = '6500-8500'
                } else if (this.$store.state.lastVocabulary < 10000){
                    this.num = '8500-10000'
                } else if (this.$store.state.lastVocabulary < 13000){
                    this.num = '10000-13000'
                } else if (this.$store.state.lastVocabulary < 15000){
                    this.num = '13000-15000'
                } else if (this.$store.state.lastVocabulary > 15000){
                    this.num = '15000+'
                }
            }
        },
        methods: {
            init: function () {
                let that = this
                this.desc = choiceDesc(this.$store.state.lastVocabulary)
                recommendBook(this.$store.state.lastVocabulary).then(function (res) {
                    that.booksList = res.data.data.result.recommendBooks
                    that.$store.commit('BOOKLIST', res.data.data.result.recommendBooks)
                })
                this.desc = choiceDesc(this.$store.state.lastVocabulary)
                getWordFrequencyRank().then(function (res) {
                    that.rankList = res.data.data.result
                })
            },
            share: function () {
                if (isYouDao != -1) {
                    let str = `不吹不黑，我的词汇量达到${this.$store.state.lastVocabulary}`
                    setShare(str, false)
                } else {
                    this.toBrowser = false
                    let str = `不吹不黑，我的词汇量达到${this.$store.state.lastVocabulary}`
                    setShare(str, true)
                    this.$store.commit('HIDDEN_INDUCE_PAGE', true)
                }
            },
            creatCard: function () {
                if (this.$store.state.userName != '') {
                    this.showButten = false
                    this.showCreatedImg = true
                    this.vocabulary = this.$store.state.lastVocabulary
                } else {
                    this.showInput = true
                    this.showButten = false
                }
            },
            closedInput: function (val) {
                this.showInput = false
                this.showButten = true
            },
            getName: function () {
                this.showInput = false
                this.vocabulary = this.$store.state.vocabulary
                this.showCreatedImg = true
                this.showButten = false
            },
            hiddenDialog: function () {
                this.showCreatedImg = false
                this.showButten = true
            },
            changeNum: function (num) {
                if (num < 10000) {
                    return num = num
                } else {
                    return `${Math.floor(num/1000)/10}w`
                }
            },
            skipout: function (data) {
                if (data.reciteType === 'list') {
                    window.location.href = `http://recite.youdao.com/share/index.html?bookId=${data.bookId}&testMode=0&reciteType=list`
                } else {
                     window.location.href = `http://recite.youdao.com/share/index.html?bookId=${data.bookId}&testMode=0&reciteType=normal`
                }
            }
        },
        components: {
            CreatImg,
            InputName,
            ShareInduce
        }
    }
</script>

<style>
    @font-face { 
        font-family: DINAlternateBold; /*这里是说明调用来的字体名字*/ 
        src: url(http://shared.youdao.com/dict/market/recite-vocabulary/fonts/DINAlternateBold.ttf); /*这里是字体文件路径*/ 
    }
    #result .banner {
        width: 100%;
        background-image: url('http://shared.youdao.com/dict/market/recite-vocabulary/img/page3_bg.png');
        background-size: 100% 100%;
        margin-bottom: 0.38rem;
        box-sizing: border-box;
        overflow: hidden;
        padding: 0.63rem 0.77rem 0.63rem 0.63rem;
    }
    #result .banner img {
        width: 2.43rem;
        height: 2.11rem;
        margin-right: 0.5rem;
        float: left;
    }
    .banner .desc {
        width: 3.17rem;
        float: left;
        overflow: hidden;
    }
    .banner .desc h6 {
        height: 0.45rem;
        font-size: 0.32rem;
        font-family: PingFangHK-Semibold;
        color: rgba(255,255,255,1);
        line-height: 0.45rem;
        margin: 0.12rem 0 0 0;
    }
    .banner .desc p {
        height: 1.04rem;
        font-size: 0.9rem;
        font-family: DINAlternateBold;
        color: rgba(255,255,255,1);
        line-height: 1.04rem;
    }
    .banner .desc span {
        font-size: 0.24rem;
        font-family: PingFangHK-Regular;
        color: rgba(255,255,255,1);
        line-height: 0.33rem;
        display: block;
    }
    #result .books {
        width: 100%;
        padding: 0 0.4rem;
        box-sizing: border-box;
    }
    #result .books p {
        height: 0.6rem;
        font-size: 0.42rem;
        font-family: PingFangSC-Semibold;
        color: rgba(72,78,94,1);
        line-height: 0.6rem;
        margin-bottom: 0.07rem;
    }
    #result .books span {
        display: block;
        height: 0.4rem;
        font-size: 0.26rem;
        font-family: PingFangSC-Regular;
        color: rgba(72,78,94,1);
        line-height: 0.4rem;
        margin-bottom: 0.4rem;
    }
    #result .books em {
        color: #FF9325;
        font-style: normal;
        font-family: DINAlternateBold;
    }
    #result .books ul {
        overflow: hidden;
        margin-bottom: 0.8rem;
    }
    #result  .books li {
        width: 1.8rem;
        float: left;
    }
    #result  .books li a {
        display: block;
        text-align: center;
    }
    #result .books li:nth-child(2n) {
        margin: 0 0.65rem;
    }
    #result .books li img {
        width: 1.8rem;
        height: 2.42rem;
        margin-bottom: 0.26rem;
        display: block;
        box-shadow: 0 0.08rem 0.2rem rgba(0, 0, 0, 0.1);
    }
    #result .books li p {
        width: 1.8rem;
        display: block;
        text-align: left;
        font-size: 0.26rem;
        font-family: PingFangSC-Semibold;
        color: rgba(72,78,94,1);
        line-height: 0.36rem;
        margin-bottom: 0.2rem;
    }
    #result .books li span {
        width: 1.8rem;
        height: 0.24rem;
        display: block;
        font-size: 0.24rem;
        text-align: left;
        font-family: PingFangSC-Regular;
        color: rgba(144,148,158,1);
        line-height: 0.24rem;
        margin: 0;
        
    }
    #result .rank {
        width: 100%;
        overflow: hidden;
    }
    #result .rank p {
        height: 0.6rem;
        font-size: 0.42rem;
        font-family: PingFangSC-Semibold;
        color: rgba(72,78,94,1);
        line-height: 0.6rem;
        margin:0 0 0.4rem 0.4rem;
    }
    .rank ul {
        overflow: hidden;
        margin-bottom: 1.36rem;
    }
    #result .rank li:nth-child(1) .medal{
        background-image: url('http://shared.youdao.com/dict/market/recite-vocabulary/imgs/page3_jiangpai1.png');
    }
    #result .rank li:nth-child(2) .medal{
        background-image: url('http://shared.youdao.com/dict/market/recite-vocabulary/imgs/page3_jiangpai2.png');
    }
    #result .rank li:nth-child(3) .medal{
        background-image: url('http://shared.youdao.com/dict/market/recite-vocabulary/imgs/page3_jiangpai3.png');
    }
    #result .rank li:nth-child(1) .vocabulary{
        color:rgba(254,165,13,1);
        font-family: DINAlternateBold;
    }
    #result .rank li:nth-child(2) .vocabulary{
        color:rgba(153,194,202,1);
        font-family: DINAlternateBold
    }
    #result .rank li:nth-child(3) .vocabulary{
        color:rgba(206,153,116,1);
        font-family: DINAlternateBold;
    }
    #result .rank li {
        width: 100%;
        padding-bottom: 0.3rem;
        border-bottom: 1px solid rgba(124,143,176,0.1);
        float: left;
        margin-bottom: 0.42rem;
    }
    #result .rank li:last-child {
        border-bottom: 0;
    }
    .rank .medal, .rank .avatar, .rank .name{ 
        float: left;
    }
    .rank .medal {
        width: 0.4rem;
        height: 0.65rem;
        margin: 0.15rem 0.3rem 0 0.46rem;
        background-size: 100% 100%;
        font-family: DINAlternateBold;
        color: rgba(233,234,236,1);
        font-size: 0.42rem;
        line-height: 0.6rem;
    }
    .rank .avatar {
        width: 0.9rem;
        height: 0.9rem;
        margin-right: 0.4rem;
        border-radius: 50%;
    }
    .rank .name {
        height: 0.9rem;
        font-size: 0.32rem;
        font-family: PingFangSC-Regular;
        color: rgba(72,78,94,1);
        line-height: 0.9rem;
    }
    .rank .vocabulary {
        width: auto;
        float: right;
        margin-right: 0.46rem;
        height: 0.9rem;
        font-size: 0.42rem;
        font-family: DINAlternateBold;
        line-height: 0.9rem;
        color: rgba(72,78,94,1);
    }
    #result .checkButton {
        width: 100%;
        height: 1.36rem;
        position: fixed;
        bottom: 0;
        z-index: 99;
        background-image: url(http://shared.youdao.com/dict/market/recite-vocabulary/imgs/mask.png);
        background-size: 100% 100%;
    }
    #result .share {
        width: 3.15rem;
        height: 1.1rem;
        margin-left: 0.4rem;
        float: left;
        background-image: url('http://shared.youdao.com/dict/market/recite-vocabulary/imgs/page3_button1.png');
        background-size: 100% 100%;
        z-index: 90;
        
    }
    #result .certificate {
        width: 3.15rem;
        height: 1.1rem;
        margin-right: 0.4rem;
        float: right; 
        background-image: url('http://shared.youdao.com/dict/market/recite-vocabulary/imgs/page3_button2.png');
        background-size: 100% 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Result.vue